import React, {memo, useEffect} from "react";

import {useLevelV2} from "~/api/hooks/useLevelV2";
import AppHeader from "~/component/common/AppHeader";
import {useGame} from "~/contexts/game-manager/GameManagerProvider";
import useLevelLoader from "~/contexts/loader/useLevelLoader";
import {useGroupSession} from "~/contexts/session/GroupSessionProvider";
import CoopMenuModalButton from "~/routes/page/coop/coop-menu/CoopMenuModalButton";

const CoopHtml: React.FC = memo(() => {
  const {gameManager} = useGame();
  const {sessionData} = useGroupSession();

  const levelId = sessionData?.current_round?.levelId;

  const {data: level} = useLevelV2({
    id: levelId,
  });

  const load = useLevelLoader();

  useEffect(() => {
    if (!levelId || !level) {
      return;
    }

    // Initial load / level change
    load(levelId, level);

    if (!gameManager) {
      return;
    }

    const handleRoundStarted = () => {
      load(levelId, level, true);
    };

    gameManager.on("round-started", handleRoundStarted);

    return () => {
      gameManager.off("round-started", handleRoundStarted);
    };
  }, [gameManager, levelId, level, load]);

  return (
    <div className="flex flex-col w-screen min-h-screen overflow-auto relative text-white bg-transparent pointer-events-none">
      <AppHeader title={level?.name} parentPath={"/home"} />
      <div className="fixed bottom-2 left-1/2 transform -translate-x-1/2 flex items-center space-x-4 z-50 pointer-events-auto">
        <CoopMenuModalButton />
      </div>
    </div>
  );
});

export default CoopHtml;
